module.exports = __webpack_public_path__ + "static/media/aditya_0kKz5IBtF5.8bebf09a.jpg";